module.exports = __webpack_public_path__ + "img/howto.f0e9a965.png";